document.addEventListener("DOMContentLoaded", function () {
  const gridOuter = document.querySelector(".grid-outer[data-products-grid]");
  const grid = gridOuter?.querySelector(".grid");
  let loading = false;
  let nextPageUrl = document.querySelector(".pagination-custom__next")?.href;

  function loadNextPage() {
    if (loading || !nextPageUrl) return;
    loading = true;

    fetch(nextPageUrl)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newProducts = doc.querySelector(".grid");
        if (newProducts) {
          Array.from(newProducts.children).forEach((child) => {
            if (!child.classList.contains("no-results")) {
              grid.appendChild(child);
            }
          });
        }
        // Update nextPageUrl for further scrolling
        const nextLink = doc.querySelector(".pagination-custom__next");
        nextPageUrl = nextLink ? nextLink.href : null;

        // Remove or hide the old pagination nav
        const oldNav = document.querySelector(".pagination-custom");
        const newNav = doc.querySelector(".pagination-custom");
        if (oldNav && newNav) {
          oldNav.innerHTML = newNav.innerHTML;
        }
        loading = false;
      });
  }

  // Intercept click on "Load more"
  document.addEventListener("click", function (e) {
    const target = e.target.closest(".pagination-custom__next");
    if (target) {
      e.preventDefault();
      loadNextPage();
    }
  });

  window.addEventListener("scroll", function () {
    if (!nextPageUrl || loading) return;
    const scrollY = window.scrollY || window.pageYOffset;
    const viewport = window.innerHeight;
    const gridBottom = gridOuter.getBoundingClientRect().bottom + scrollY;
    if (scrollY + viewport > gridBottom - 200) {
      loadNextPage();
    }
  });
});
